import { THERAPY_ACTION_TYPES } from '../../actions/therapy/therapy_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const therapies = (state = initialState, action) => {
    switch (action.type) {
        case THERAPY_ACTION_TYPES.GET_THERAPIES_SUCCESS:
            return { ...state, collection: action.payload };
        case THERAPY_ACTION_TYPES.POST_THERAPY_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case THERAPY_ACTION_TYPES.PUT_THERAPY_SUCCESS:
            const updatedTherapy = action.payload;
            return { ...state, collection: state.collection.map((therapy) => therapy.uuid !== updatedTherapy.uuid ? therapy : { ...therapy, ...updatedTherapy }) };
        case THERAPY_ACTION_TYPES.UPDATE_THERAPIES_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
